import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  TextField,
} from "@mui/material";
import Comment from "../Comment/Comment";
import { useMainStore } from "../../Zustand/main.store";
import { ExpandMore } from "@mui/icons-material";
import { useEffect, useState } from "react";
import {
  useApiCreateComments,
  useApiCreateLog,
  useApiGetComments,
} from "../../API/comments.api";
import { Comments } from "../../API/types/comments.types";
import { useAuthStore } from "../../Zustand/auth.store";
import { useNotificationStore } from "../../Zustand/notification.store";
import clsx from "clsx";

const CommentBox = () => {
  /**
   * Custom hooks
   */
  const selectedPdfId = useMainStore((s) => s.selectedPdfId);
  const fullName = useAuthStore((s) => s.fullName);
  const workdayUsername = useAuthStore((s) => s.workdayUsername);
  const showNotification = useNotificationStore((s) => s.show);

  /**
   * States
   */
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState<Comments[]>();

  /**
   * API
   */
  // 🟣 API - Get all comments from
  const { call: callGetComments } = useApiGetComments({
    onCompleted: (res) => {
      setComments(res.data);
    },
  });

  const { call: callCreateComment } = useApiCreateComments({
    onCompleted: () => {
      showNotification("Comment created", "success");
      if (selectedPdfId) {
        callGetComments(selectedPdfId);
        callCreateLog(selectedPdfId);
      }
    },
  });

  const { call: callCreateLog } = useApiCreateLog();

  /**
   * Callbacks
   */
  const handleSubmit = (event: React.SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();
    setComment("");
    selectedPdfId &&
      callCreateComment({
        comment,
        documentId: selectedPdfId,
        userName: fullName ?? "N/A",
        workdayUsername: workdayUsername ?? "",
      });
  };

  const handleChangeComment = (event: any) => {
    setComment(event.target.value);
  };

  /**
   * Effects
   */
  useEffect(() => {
    selectedPdfId ? callGetComments(selectedPdfId) : setComments([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPdfId]);

  return (
    <div className="w-[95%] mx-auto">
      <hr className="mb-10" />
      <Accordion>
        <AccordionSummary
          aria-controls="panel1-content"
          expandIcon={<ExpandMore />}
          id="panel1-header"
        >
          <h2 className="font-bold">Add a Comment</h2>
        </AccordionSummary>
        <AccordionDetails>
          <form
            className="flex flex-col gap-5"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            {/* <TextField
              className="w-[70%]"
              error={false}
              id="name"
              label="Name"
              value={name}
              required
              helperText=""
              onChange={handleChangeName}
            /> */}
            <p>User: {fullName}</p>
            <TextField
              className="w-[70%]"
              id="comment"
              label="Comment"
              placeholder="Add a comment..."
              name="comment"
              value={comment}
              multiline
              rows={4}
              inputProps={{ maxLength: 300 }}
              required
              variant="standard"
              helperText={`${comment.length}/300`}
              onChange={handleChangeComment}
            />
            <button
              className={clsx(
                "text-white font-bold py-2 px-5 roundeds w-[200px]",
                comment === "" ? "bg-gray-400" : "bg-blue-500"
              )}
              disabled={comment === ""}
            >
              Comment
            </button>
          </form>
        </AccordionDetails>
      </Accordion>

      <div className="flex flex-col text-end mt-5">
        <p>{comments?.length ?? 0} Comment(s) </p>
        <hr className="mt-2" />
      </div>
      {/* Comments */}
      <div className="w-full h-[300px] overflow-auto mt-5">
        {comments &&
          comments.map(
            (comment) =>
              comment && (
                <Comment
                  key={comment.id}
                  commentData={comment}
                  onChanged={() =>
                    selectedPdfId && callGetComments(selectedPdfId)
                  }
                />
              )
          )}
      </div>
    </div>
  );
};

export default CommentBox;
